// Role helpers for the 3-role system (Stage 1: routing/views only).
// Roles: 'sme_user' (end user / business owner), 'accountant' (+ staff later),
// 'admin' (super admin). Backend/API-level enforcement is added in Stage 2.

export const isEndUserRole = (role) => role === 'sme_user';

// Where each role lands after login / when hitting a route they shouldn't.
export const homePathForRole = (user) => {
    const role = user?.role;
    if (role === 'admin') return '/app/admin';
    if (role === 'accountant') return '/app/portfolio';
    // end user (sme_user) and any unknown role -> client inbox
    return '/inbox';
};
